import React from "react";
import { Carousel, Col, Divider, Row } from "antd";
import "./index.scss";
import { Link } from "react-router-dom";

const testimonials = [
  {
    headerText: "COMMITMENT",
    description:
      "Our clients have confidence in our commitment to commence the job on time and finish it on time. We strive constantly to meet and exceed our client's expectations.",
    imagePath: "commitment.png",
  },
  {
    headerText: "COLLABORATION",
    description:
      "CDC helps in Collaboration of People and Entities to complete a project at hand with accountability.",
    imagePath: "partners.png",
  },
  {
    headerText: "CUSTOMER CENTRIC",
    description:
      "All our solutions and services are catered with customer centric approach and we provide highest possible levels of commitment and delivery.",
    imagePath: "protect.png",
  },
  {
    headerText: "DIVERSITY",
    description:
      "We work with the diverse range of clients and skills across many industry verticals to widen our scope of business and reach.",
    imagePath: "diversity.png",
  },
  {
    headerText: "DELIVERY",
    description:
      "We thrive in our abilities when it comes to delivering a candidate on a project or provide a time sensitive solution.",
    imagePath: "delivery-box.png",
  },
  {
    headerText: "DETAIL ORIENTED",
    description:
      "A trait we have to pay close attention and notice to minor details needed for the job at hand.",
    imagePath: "customer-service.png",
  },
  {
    headerText: "COST",
    description:
      "Our products and services are reasonably priced to best serve our customers and our profitability.",
    imagePath: "salary.png",
  },
  {
    headerText: "CORE",
    description:
      "The Core of CDC is in the business value of Hiring Right Candidate with passion and integrity.",
    imagePath: "chemicals.png",
  },
  {
    headerText: "CONCEPT",
    description:
      "Our business ideas and thoughts are derived from Technological Products, Human Processes and Ergonomically mastered procedures.",
    imagePath: "briefing.png",
  },
];

const hiringVerticals = [
  { imagePath: "design.png", text: "UI/UX Designers" },
  { imagePath: "customer-support.png", text: "Desktop Support" },
  { imagePath: "devops.png", text: "DevOps" },
  { imagePath: "analyst.png", text: "Data Scientist/Analyst" },
  { imagePath: "testing.png", text: "QA Software Testing" },
  { imagePath: "cloud-computing.png", text: "Cloud Computing" },
  { imagePath: "data-warehouse.png", text: "Data Warehousing" },
  { imagePath: "data-network.png", text: "Data Architecture" },
  { imagePath: "app.png", text: "Application Architecture" },
  { imagePath: "secure.png", text: "Data Governance" },
  { imagePath: "analytics (1).png", text: "Project-Management" },
  { imagePath: "infrastructure.png", text: "Network Infrastructure" },
  { imagePath: "data.png", text: "Web Design & Development" },
  { imagePath: "analyst (1).png", text: "Business Analyst" },
  { imagePath: "process.png", text: "Enterprise Architecture" },
  { imagePath: "communications.png", text: "Application Tech Support" },
  {
    imagePath: "digital-services.png",
    text: "Integration management and Development",
  },
  { imagePath: "cyber-security.png", text: "Cyber-security" },
  { imagePath: "database-management.png", text: "Data Management" },
  {
    imagePath: "professional.png",
    text: "Information Technology Professionals",
  },
];

const businessVerticals = [
  {
    imagePath: "money.png",
    text: "FINANCE",
  },
  {
    imagePath: "healthcare.png",
    text: "Healthcare & Nursing",
  },
  {
    imagePath: "shopping-store.png",
    text: "Retail",
  },
  {
    imagePath: "accounting.png",
    text: "Accounting",
  },
  {
    imagePath: "life-insurance.png",
    text: "LIFE SCIENCES",
  },
  {
    imagePath: "government.png",
    text: "Government",
  },
  {
    imagePath: "graduation-cap.png",
    text: "Education",
  },
  {
    imagePath: "networking.png",
    text: "Communications",
  },
];

const bottomCarouselContent = [
  {
    content:
      "CDC’s overall service in the areas of recruiting, screening and assessment of candidates, personalized customer service and the relationships they maintain with their employees are the kind of traits that our company looks for in a staffing vendor.",
  },
  {
    content:
      "As a client, we have consistently found CDC as an important partner for hiring talented people. CDC has been able to provide us with the best in class  services. I can recommend CDC as an excellent business partner with a passion to provide quality candidates that fit our needs.",
  },
  {
    content:
      "CDC has been our business partner for several years. They have been able to meet our needs for temporary and permanent staffing needs. In addition, their turnaround time is quick, and customer service is among the best",
  },
  {
    content:
      "Our company partnered with CDC for our key staffing and recruitment needs.  They have consistently shown a great ability in finding the top talent we need to help grow our firm.  We have found they work as a true partner with our team to insure we have the right person, with the right skills, and right fit for our team",
  },
];

const Home = () => {
  return (
    <div className="home-main">
      {/* HERO / CAROUSEL */}

      <Carousel effect="fade" dotPosition="bottom" arrows>
        {/* Slide 1 */}

        <div className="carousel-bckgrnds-first">
          <div className="carousel-content">
            <h2 className="slide-title">PEOPLE & POSSIBILITIES</h2>
            <h4 className="slide-subtitle">
              FUTURE BELONGS TO PEOPLE WHO SEE POSSIBILITIES BEFORE THEY BECOME
              OBVIOUS
            </h4>
          </div>
        </div>

        {/* Slide 2 */}

        <div className="carousel-bckgrnds-second">
          <div className="carousel-content">
            <h2 className="slide-title">DO YOU NEED TO HIRE PEOPLE?</h2>
            <h4 className="slide-subtitle">WE ARE HERE TO MAKE IT POSSIBLE.</h4>
            <p className="slide-cta">
              <span className="contact-usebtn">
                <Link to="/contact">CONTACT US</Link>
              </span>
            </p>
          </div>
        </div>

        {/* Slide 3 */}

        <div className="carousel-bckgrnds-third">
          <div className="carousel-content">
            <h2 className="slide-title">ARE YOU HIRING RIGHT ?</h2>
            <h4 className="slide-subtitle">
              IT DOES NOT MAKE SENSE TO HIRE SMART PEOPLE AND THEN TELL THEM
              WHAT TO DO
            </h4>
          </div>
        </div>
      </Carousel>
      {/* ABOUT */}
      <section>
        <Row>
          <Col
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            lg={{ span: 20, offset: 2 }}
            md={{ span: 20, offset: 2 }}
            xl={{ span: 20, offset: 2 }}
          >
            <div className="about-us-inner-container">
              <h2 className="about-us-text">
                <Divider>
                  <span className="about-us-text">About Us</span>
                </Divider>
              </h2>
              <div className="window-comp">
                <Row>
                  <Col
                    xs={{ span: 24 }}
                    lg={{ span: 24 }}
                    xl={{ span: 12 }}
                    md={{ span: 24 }}
                    className="about-image-col"
                  >
                    <div className="about-image-col"></div>
                  </Col>
                  <Col
                    xs={{ span: 24 }}
                    lg={{ span: 24 }}
                    xl={{ span: 12 }}
                    md={{ span: 24 }}
                  >
                    <div className="welcomecdc-container">
                      <h3>Welcome to CDC</h3>
                      <p>
                        Computer Data Concepts ( CDC ) is innovation of
                        excellence to provide talent acquisition services.
                        Backed by two decades of IT industry specialists and
                        entrepreneurs CDC provides IT & IT Enabled services to
                        prioritize the staffing needs of our valued clients
                      </p>
                      <br />
                      <br />
                      <br />
                      <br />
                      <Link className="know-more-btn" to="/about">
                        Know More
                      </Link>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
            {/* SERVICES TEXT */}
            <section id="main-container">
              <div>
                <p className="text-para-2">
                  We boast of our expertise and two decades of experience in
                  providing Technical, Non-Technical and Managerial solutions
                  and skills to our customers. We provide Staffing Services that
                  cater to the specific needs of our customers. We adhere to the
                  Statement of Work, Timeline and Costs described and agreed
                  upon with the customer. With two decades of experience that
                  have contributed to our success, we extend our gratitude to
                  our clients and candidates for their trust and confidence in
                  our proven ability to deliver timely and accurate
                  solutions.Commitment is in the core of our Detail oriented
                  approach that we achieve through Cost Effectiveness and
                  Diversification.
                </p>

                <div>
                  <Row>
                    {testimonials?.map((card, index) => {
                      return (
                        <Col
                          xs={{ span: 24 }}
                          sm={{ span: 24 }}
                          md={{ span: 10 }}
                          lg={{ span: 6, offset: 2 }}
                          xl={{ span: 6, offset: 2 }}
                          className="testimonial-card-content"
                        >
                          <img
                            src={`/images/services/${card.imagePath}`}
                            alt={card.headerText}
                            width="75"
                            height="75"
                          />
                          <div className="header">{card.headerText}</div>
                          <div className="description">{card.description}</div>
                        </Col>
                      );
                    })}
                  </Row>
                  <div></div>
                </div>
              </div>
            </section>
          </Col>
        </Row>
        {/* Hiring Verticals Section */}
        <Row className="hiring-vertical-main">
          <Col
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            lg={{ span: 20, offset: 2 }}
            md={{ span: 20, offset: 2 }}
            xl={{ span: 20, offset: 2 }}
          >
            <div className="hiring-header">Hiring Verticals</div>
            <div className="hiring-subheader">
              We have worked across many verticals to provide end-to-end
              staffing solutions for our customers.
            </div>
            <Row>
              {hiringVerticals?.map((hVertical, index) => {
                return (
                  <Col
                    xs={{ span: 12 }}
                    sm={{ span: 12 }}
                    lg={{ span: 4, offset: 2 }}
                    md={{ span: 4, offset: 2 }}
                    xl={{ span: 4, offset: 2 }}
                    className="vertical-cards"
                  >
                    <img
                      src={`/images/hiring/${hVertical.imagePath}`}
                      alt={hVertical.text}
                      width="75"
                      height="75"
                    />
                    <div>{hVertical?.text}</div>
                  </Col>
                );
              })}
            </Row>
          </Col>
        </Row>
        {/* Business verticals */}
        <Row className="business-vertical-main">
          <Col
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            lg={{ span: 20, offset: 2 }}
            md={{ span: 20, offset: 2 }}
            xl={{ span: 20, offset: 2 }}
          >
            <div className="business-header">
              Business Verticals in Staffing
            </div>
            <Row>
              {businessVerticals?.map((hVertical, index) => {
                return (
                  <Col
                    xs={{ span: 12 }}
                    sm={{ span: 12 }}
                    lg={{ span: 4, offset: 2 }}
                    md={{ span: 4, offset: 2 }}
                    xl={{ span: 4, offset: 2 }}
                    className="business-vertical-card"
                  >
                    <img
                      src={`/images/icons/${hVertical.imagePath}`}
                      alt={hVertical.text}
                      width="75"
                      height="75"
                    />
                    <div>{hVertical?.text}</div>
                  </Col>
                );
              })}
            </Row>
          </Col>
        </Row>

        {/* bottom Carousel */}
        <Row className="bottom-carousel-main">
          <Col
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            lg={{ span: 20, offset: 2 }}
            md={{ span: 20, offset: 2 }}
            xl={{ span: 20, offset: 2 }}
          >
            <Carousel>
              {bottomCarouselContent.map((carouselContent) => {
                return (
                  <div className="carousel-content">
                    <span></span>
                    {carouselContent.content}
                    <span></span>
                  </div>
                );
              })}
            </Carousel>
          </Col>
        </Row>

        {/* Client Carousel */}
        <Row className="client-carousel-main">
          <Col
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            lg={{ span: 20, offset: 2 }}
            md={{ span: 20, offset: 2 }}
            xl={{ span: 20, offset: 2 }}
          >
            <Carousel autoplay>
              <div className="bottom-carousel-content">
                <img src={`/images/clients/1.png`} alt="client-img" />
                <img src={`/images/clients/2.png`} alt="client-img" />
                <img src={`/images/clients/3.png`} alt="client-img" />
                <img src={`/images/clients/4.png`} alt="client-img" />
                <img src={`/images/clients/5.png`} alt="client-img" />
              </div>
              <div className="bottom-carousel-content">
                <img src={`/images/clients/6.png`} alt="client-img" />
                <img src={`/images/clients/7.png`} alt="client-img" />
                <img src={`/images/clients/8.png`} alt="client-img" />
                <img src={`/images/clients/9.png`} alt="client-img" />
              </div>
            </Carousel>
          </Col>
        </Row>
      </section>
    </div>
  );
};

export default Home;
